import {forwardRef} from 'react';
import {BleskIconWithVariant} from '../types';
import {BaseIcon} from './BaseIcon';

export const Star: BleskIconWithVariant = forwardRef(function Star({variant, ...rest}, ref) {
  return (
    <BaseIcon {...rest} ref={ref}>
      {variant === 'default' && (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.73112 20.8328C7.22404 21.0975 6.6106 21.0509 6.14933 20.7126C5.68807 20.3744 5.45921 19.8033 5.55921 19.2401L6.36855 14.6012L2.96113 11.3358C2.54463 10.9386 2.39199 10.3382 2.56823 9.79034C2.74446 9.24246 3.21852 8.84364 3.78847 8.76375L8.51945 8.08747L10.6553 3.8267C10.9086 3.31571 11.4296 2.99243 11.9999 2.99243C12.5702 2.99243 13.0912 3.31571 13.3445 3.8267L15.4803 8.08747L20.2113 8.76375C20.7813 8.84364 21.2553 9.24246 21.4316 9.79034C21.6078 10.3382 21.4552 10.9386 21.0387 11.3358L17.6312 14.6012L18.4406 19.2411C18.5406 19.8043 18.3117 20.3754 17.8505 20.7136C17.3892 21.0519 16.7757 21.0985 16.2687 20.8338L11.9999 18.6279L7.73112 20.8328Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}

      {variant === 'fill' && (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.73112 20.8328C7.22404 21.0975 6.6106 21.0509 6.14933 20.7126C5.68807 20.3744 5.45921 19.8033 5.55921 19.2401L6.36855 14.6012L2.96113 11.3358C2.54463 10.9386 2.39199 10.3382 2.56823 9.79034C2.74446 9.24246 3.21852 8.84364 3.78847 8.76375L8.51945 8.08747L10.6553 3.8267C10.9086 3.31571 11.4296 2.99243 11.9999 2.99243C12.5702 2.99243 13.0912 3.31571 13.3445 3.8267L15.4803 8.08747L20.2113 8.76375C20.7813 8.84364 21.2553 9.24246 21.4316 9.79034C21.6078 10.3382 21.4552 10.9386 21.0387 11.3358L17.6312 14.6012L18.4406 19.2411C18.5406 19.8043 18.3117 20.3754 17.8505 20.7136C17.3892 21.0519 16.7757 21.0985 16.2687 20.8338L11.9999 18.6279L7.73112 20.8328Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}

      {variant === 'duotone' && (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.73112 20.8328C7.22404 21.0975 6.6106 21.0509 6.14933 20.7126C5.68807 20.3744 5.45921 19.8033 5.55921 19.2401L6.36855 14.6012L2.96113 11.3358C2.54463 10.9386 2.39199 10.3382 2.56823 9.79034C2.74446 9.24246 3.21852 8.84364 3.78847 8.76375L8.51945 8.08747L10.6553 3.8267C10.9086 3.31571 11.4296 2.99243 11.9999 2.99243C12.5702 2.99243 13.0912 3.31571 13.3445 3.8267L15.4803 8.08747L20.2113 8.76375C20.7813 8.84364 21.2553 9.24246 21.4316 9.79034C21.6078 10.3382 21.4552 10.9386 21.0387 11.3358L17.6312 14.6012L18.4406 19.2411C18.5406 19.8043 18.3117 20.3754 17.8505 20.7136C17.3892 21.0519 16.7757 21.0985 16.2687 20.8338L11.9999 18.6279L7.73112 20.8328Z"
          stroke="currentColor"
          fill="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </BaseIcon>
  );
});
